export interface DealVariant {
  dealId: string
  dealTitle: string
  dealText: string
  dealName?: string
  dealImg?: string
}

export const DEAL_VARIANTS_UK: DealVariant[] = [
  {
    dealId: "fallback", // dealIds to be mapped once we will get data from graph
    dealTitle: "admin.components.yourPerkboxStory.numberOfRedemptions.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.fallback",
    dealName: "admin.components.yourPerkboxStory.redemptions.fallback"
  },
  {
    dealId: "caffeNero",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.caffeNero.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.caffeNero.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.caffeNero.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.caffeNero.img"
  },
  {
    dealId: "greggs",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.greggs.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.greggs.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.greggs.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.greggs.img"
  },
  {
    dealId: "deliveroo",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.deliveroo.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.deliveroo.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.deliveroo.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.deliveroo.img"
  },
  {
    dealId: "tesco",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.tesco.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.tesco.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.tesco.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.tesco.img"
  },
  {
    dealId: "amazon",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.amazon.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.amazon.text",
    dealImg: "admin.components.yourPerkboxStory.redemptions.amazon.img"
  },
  {
    dealId: "apple",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.apple.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.apple.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.apple.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.apple.img"
  },
  {
    dealId: "rakuten",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.rakuten.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.rakuten.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.rakuten.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.rakuten.img"
  },
  {
    dealId: "cineworld",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.cineworld.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.cineworld.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.cineworld.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.cineworld.img"
  },
  {
    dealId: "vue",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.vue.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.vue.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.vue.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.vue.img"
  },
  {
    dealId: "odeon",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.odeon.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.odeon.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.odeon.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.odeon.img"
  },
  {
    dealId: "currys",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.currys.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.currys.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.currys.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.currys.img"
  },
  {
    dealId: "mygym",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.mygym.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.mygym.text",
    dealImg: "admin.components.yourPerkboxStory.redemptions.mygym.img"
  },
  {
    dealId: "samsung",
    dealTitle: "admin.components.yourPerkboxStory.redemptions.samsung.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.samsung.text",
    dealName: "admin.components.yourPerkboxStory.redemptions.samsung.name",
    dealImg: "admin.components.yourPerkboxStory.redemptions.samsung.img"
  }
]

export const DEAL_VARIANTS_AUS: DealVariant[] = [
  {
    dealId: "fallback",
    dealTitle: "admin.components.yourPerkboxStory.numberOfRedemptions.title",
    dealText: "admin.components.yourPerkboxStory.redemptions.fallback",
    dealName: "admin.components.yourPerkboxStory.redemptions.fallback"
  },
  {
    dealId: "woolworths",
    dealTitle: "admin.components.yourPerkboxStory.woolworths.title",
    dealText: "admin.components.yourPerkboxStory.woolworths.text",
    dealName: "admin.components.yourPerkboxStory.woolworths.name",
    dealImg: "admin.components.yourPerkboxStory.woolworths.img"
  },
  {
    dealId: "amazon2",
    dealTitle: "admin.components.yourPerkboxStory.amazon.title2",
    dealText: "admin.components.yourPerkboxStory.amazon.text2",
    dealImg: "admin.components.yourPerkboxStory.amazon.img2"
  },
  {
    dealId: "apple2",
    dealTitle: "admin.components.yourPerkboxStory.apple.title2",
    dealText: "admin.components.yourPerkboxStory.apple.text2",
    dealName: "admin.components.yourPerkboxStory.apple.name2",
    dealImg: "admin.components.yourPerkboxStory.apple.img2"
  },
  {
    dealId: "coles",
    dealTitle: "admin.components.yourPerkboxStory.coles.title",
    dealText: "admin.components.yourPerkboxStory.coles.text",
    dealName: "admin.components.yourPerkboxStory.coles.name",
    dealImg: "admin.components.yourPerkboxStory.coles.img"
  },
  {
    dealId: "samsung2",
    dealTitle: "admin.components.yourPerkboxStory.samsung.title2",
    dealText: "admin.components.yourPerkboxStory.samsung.text2",
    dealName: "admin.components.yourPerkboxStory.samsung.name2",
    dealImg: "admin.components.yourPerkboxStory.samsung.img2"
  },
  {
    dealId: "iconic",
    dealTitle: "admin.components.yourPerkboxStory.iconic.title",
    dealText: "admin.components.yourPerkboxStory.iconic.text",
    dealName: "admin.components.yourPerkboxStory.iconic.name",
    dealImg: "admin.components.yourPerkboxStory.iconic.img"
  },
  {
    dealId: "jbHifi",
    dealTitle: "admin.components.yourPerkboxStory.jbHifi.title",
    dealText: "admin.components.yourPerkboxStory.jbHifi.text",
    dealName: "admin.components.yourPerkboxStory.jbHifi.name",
    dealImg: "admin.components.yourPerkboxStory.jbHifi.img"
  },
  {
    dealId: "hotelPlanner",
    dealTitle: "admin.components.yourPerkboxStory.hotelPlanner.title",
    dealText: "admin.components.yourPerkboxStory.hotelPlanner.text",
    dealName: "admin.components.yourPerkboxStory.hotelPlanner.name",
    dealImg: "admin.components.yourPerkboxStory.hotelPlanner.img"
  }
]
